import { render, staticRenderFns } from "./shenOverTimeDetail.vue?vue&type=template&id=5638dde0&"
import script from "./shenOverTimeDetail.vue?vue&type=script&lang=js&"
export * from "./shenOverTimeDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenOverTimeDetail.vue?vue&type=style&index=0&id=5638dde0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports